<!-- Desktop: Static sidebar -->
@if (!isMobile && visible) {
<aside class="w-64 h-full border-r flex-shrink-0">
  <nav class="p-4 h-full overflow-y-auto flex flex-col">
    <p-divider align="left">
      <span class="text-label-md">{{ 'home.navigation' | translate }}</span>
    </p-divider>

    <div class="flex-1 overflow-y-auto">
      <!-- PanelMenu for navigation -->
      <p-panelmenu [model]="menuItems" styleClass="w-full"></p-panelmenu>
    </div>

    <!-- Logout button at the bottom -->
    <div class="mt-auto pt-4">
      <p-divider></p-divider>
      <a
        (click)="logout()"
        pButton
        [outlined]="true"
        icon="pi pi-sign-out"
        [label]="'common.logout' | translate"
        class="p-button-fluid !justify-start p-button-danger"
      >
      </a>
    </div>
  </nav>
</aside>
}

<!-- Mobile: Drawer overlay -->
@if (isMobile) {
<p-drawer
  [(visible)]="visible"
  [modal]="true"
  position="left"
  [showCloseIcon]="true"
  styleClass="sidenav-drawer"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header">
    <p-divider align="left">
      <span class="text-label-md">{{ 'home.navigation' | translate }}</span>
    </p-divider>
  </ng-template>

  <div class="flex flex-col h-full">
    <div class="flex-1 overflow-y-auto">
      <!-- PanelMenu for navigation -->
      <p-panelmenu [model]="menuItems" styleClass="w-full"></p-panelmenu>
    </div>

    <!-- Logout button at the bottom -->
    <div class="mt-auto pt-4">
      <p-divider></p-divider>
      <a
        (click)="logout()"
        pButton
        [outlined]="true"
        icon="pi pi-sign-out"
        [label]="'common.logout' | translate"
        class="p-button-fluid !justify-start p-button-danger"
      >
      </a>
    </div>
  </div>
</p-drawer>
}
